export default "__VITE_ASSET__BBDsN_1X__"